import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiDataDup } from "../../../../redux/reducers/commonApiSlice";
import { attendanceGet } from "../../../../data/ApiEndpoints";
import TableSkeleton from "../../../common-components/TableSkeleton";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { ReloadIcon } from "../../../../images/icons/icons";
import { convertStraight } from "../../../common-data/Converts";

const MemberAttendance = ({
  userInfoData,
  prevFilters,
  setModValues,
  memberAttendanceRef,
  closeSection,
}) => {
  const dispatch = useDispatch();
  const { dataDup, loadingDup, errorDup } = useSelector(
    (state) => state.common
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit,
    gym_id: prevFilters?.gym_id || "",
    account_type: "member",
    date_from: prevFilters?.start_date
      ? convertStraight(prevFilters.start_date)
      : "",
    date_to: prevFilters?.end_date
      ? convertStraight(prevFilters.end_date || "")
      : "",
    slot_time: prevFilters?.checkin_time_filter || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  function getCheckinsStatData(filters) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: attendanceGet,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters?.gym_id) {
      getCheckinsStatData(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
      gym_id: prevFilters?.gym_id || "",
      date_from: prevFilters?.start_date
        ? convertStraight(prevFilters.start_date)
        : "",
      date_to: prevFilters?.end_date
        ? convertStraight(prevFilters.end_date || "")
        : "",
      slot_time: prevFilters?.checkin_time_filter || "",
    }));
  }, [
    isPage,
    pageLimit,
    prevFilters?.gym_id,
    prevFilters?.start_date,
    prevFilters?.end_date,
    prevFilters?.checkin_time_filter,
  ]);

  useEffect(() => {
    if (!loadingDup && !errorDup && dataDup?.status) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: dataDup?.data,
        pagination: dataDup?.pagination?.length > 0 ? dataDup.pagination : [],
        totalSale: dataDup?.total ? dataDup.total : 0,
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [dataDup, errorDup, loadingDup]);

  const tbColumns = [
    {
      dataField: "user_name",
      text: "Member Info",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.user_name || "NA"}</span>;
      },
    },
    {
      dataField: "mobile",
      text: "Member mobile",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.mobile || "NA"}</span>;
      },
    },
    {
      dataField: "email",
      text: "Member email",
      formatter: (_, row) => {
        return <span className="tb-data lowercase">{row?.email || "NA"}</span>;
      },
    },
    {
      dataField: "date",
      text: "checkin date",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.date || "-"}</span>;
      },
    },
    {
      dataField: "date",
      text: "checkin time",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.time || "-"}</span>;
      },
    },
  ];

  return (
    <div className="mr-full-width-section" ref={memberAttendanceRef}>
      <div className="mr-section-header">
        <div className="mr-section-header-left">
          <h2 className="mr-section-title">Member Attendance</h2>
          <p className="mr-section-subtitle">Member checkin detailed history</p>
        </div>
        <div className="mr-section-header-right">
          <button
            className="mr-section-reload-btn"
            onClick={() => getCheckinsStatData(filters)}
            title="Reload data"
          >
            {ReloadIcon()}
          </button>
          <button
            className="mr-section-close-btn"
            onClick={closeSection}
            title="Close section"
          >
            ×
          </button>
        </div>
      </div>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-0 mb30">
        {loadingDup ? (
          <TableSkeleton columns={10} rows={10} />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            tablePagination={tbDatas.pagination}
          />
        )}
      </div>
    </div>
  );
};

export default MemberAttendance;
